export interface ParsedFactoid {
  heading: string | null;
  description: React.ReactNode;
  sortOrder: number | null;
}

export const backgroundColors = {
  transparent: "bg-transparent",
  elm: "bg-primary-500",
  putty: "bg-putty-100",
  blue: "bg-[#122A4B]",
  white: "bg-white",
};

export type StatsBackground =
  | "elm"
  | "putty"
  | "transparent"
  | "blue"
  | "white";

export type StatsVariant =
  | "default"
  | "transparent"
  | "light-logo"
  | "dark-logo"
  | "dark-logo-nogap";

export type TaxiFormData = Record<string, any>;

export type HeroStatsProps = {
  variant?: StatsVariant;
  hasUsNewsLogo?: boolean;
  rankingAvailable?: boolean;
  courseDetails?: ParsedFactoid[];
  background?: StatsBackground;
  colorBarHexValue?: string;
};
